import React from "react";

import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import useFirebase from "../../../../../../config/context/firebaseContext";
import useMainState from "../../../../../../config/context/mainStateContext";
import useModal from "../../../../../../config/context/modalContext";
import { GreyPallet } from "../../../../../../config/styles";

import MainText from "../../../../../../components/MainText";
import CafeteriaCard from "./components/CafeteriaCard";

import { CafeteriaType } from "../../../../../../types/database";

export default function CafeteriaPage({ cafeterias }: { cafeterias: CafeteriaType[] }) {
  const navigate = useNavigate();

  const { functions, analyticLog } = useFirebase();

  const { setShowSideMenuDrawer } = useMainState();
  const { pushAlert } = useModal();

  const [loading, setLoading] = React.useState(false);

  const [tabShow, setTabShow] = React.useState("ru");

  const [showDetail, setShowDetail] = React.useState(false);

  React.useEffect(() => {}, []);

  return (
    <Box width={"100%"} sx={{ "& *": { boxSizing: "border-box" } }}>
      <Box sx={{ backgroundColor: GreyPallet.Light, borderRadius: "15px", mb: 2, p: 2 }}>
        <MainText size="caption">Pedidos somente para retirada!</MainText>
      </Box>

      {cafeterias.map((cafeteria) => (
        <CafeteriaCard key={cafeteria.id} item={cafeteria} />
      ))}
    </Box>
  );
}
